import React, { useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
// import CodeSystemDialogRows from './CodeSystemDialogRows';
import ValueSetDialogData from './ValueSetDialogData';
import { GlobalContext } from '../contexts/GlobalContext';
import './ValueSetDialog.css';
import ValueSetDialogJson from './ValueSetDialogJson';
import ValueSetDialogTags from './ValueSetDialogTags';
import ValueSetDialogCompose from './ValueSetDialogCompose';
import ValueSetDialogExpansion from './ValueSetDialogExpansion';


const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
}));

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={2}>{children}</Box>}
		</div>
	);
}

function ValueSetDialog(props) {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const globals = useContext(GlobalContext)

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	useEffect(() => {
		globals.initAnalytics();
		globals.logEventAnalytics(
			"ValueSet",
			"VS - Display Modal",
			props.name);
	}, [globals, props.name])

	function valueComposeLabel(data) {
		if (data.compose === null || data.compose === undefined)
			return (<div>Compose  <Chip size='small' label='0' color='secondary' /></div>)

		var cntInclude = data.compose.include.length;
		var cntExclude = (data.compose.exclude) ? data.compose.exclude.length : 0;
		return (<div>Compose  <Chip size='small' label={cntInclude + " / " + cntExclude} color='primary' /></div>)
	}

	function valueMetaDataLabel(data) {
		var count = 0;

		if (data.meta === null || data.meta === undefined)
			return (<div>Metadata  <Chip size='small' label='0' color='secondary' /></div>)

		if (data.meta.tag === null || data.meta.tag === undefined)
			return (<div>Metadata  <Chip size='small' label='0' color='secondary' /></div>)

		count = data.meta.tag.filter(item => item.system === globals.tagSystem).length
		return (<div>Metadata  <Chip size='small' label={count} color='primary' /></div>)
	}

	return (
		<Paper className={classes.root}>
			<Tabs
				value={value}
				onChange={handleChange}
				indicatorColor="primary"
				textColor="primary"
				variant="fullWidth"
			>
				<Tab label="Definition" />
				<Tab label={valueComposeLabel(props)} />
				<Tab label="Expansion" />

				<Tab label={valueMetaDataLabel(props)} />
				<Tab label="JSON" />

			</Tabs>
			<TabPanel value={value} index={0}>
				<div className="simpleTabPanel">
					<ValueSetDialogData {...props} />
				</div>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<div className="simpleTabPanel">
					<ValueSetDialogCompose {...props} />
				</div>
			</TabPanel>
			<TabPanel value={value} index={2}>
				<div className="simpleTabPanel">
					<ValueSetDialogExpansion {...props} />
				</div>
			</TabPanel>
			<TabPanel value={value} index={3}>
				<div className="simpleTabPanel">
					<ValueSetDialogTags {...props} />
				</div>
			</TabPanel>
			<TabPanel value={value} index={4}>
				<div className="simpleTabPanel">
					<ValueSetDialogJson {...props} />
				</div>
			</TabPanel>
		</Paper>
	);
}

export default ValueSetDialog;
